import { default as RBaseInteraction } from './RBaseInteraction';
/**
 * A basic pointer interaction component
 *
 * It is meant to be be extended by more specific interactions
 */
class RPointer extends RBaseInteraction {
}
RPointer.classProps = [
    'handleDownEvent',
    'handleDragEvent',
    'handleMoveEvent',
    'handleUpEvent'
];
export default RPointer;
//# sourceMappingURL=RPointer.js.map